// extracted by mini-css-extract-plugin
export default {"color-picker-container":"ColorPicker_color-picker-container__FMzQA"};